import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';

const LivestreamViewer = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const [nutxuly, setnutxuly] = useState(0);
    const [showcaptcha, setshowcaptcha] = useState(false);
    const [nutorder, setnutorder] = useState('Thanks =D');
    const [comments, setComments] = useState([]);
    const [inputComment, setInputComment] = useState('');
    const audioRef = useRef(null);

    const { slug_2 } = useParams();

    return (
        <>
            <Helmet>
                <title>Lịch sử</title>
            </Helmet>
            <div className="mt-2 flex flex-wrap ">
                <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                    <Link to="/shop/creative/history_create?app=showadview" className="no-underline">
                        <div className="max-w-7xl mx-2 py-0 mb-0">
                            <div className="relative group">
                                <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                    <div className="space-y-2">
                                        <div className="text-lg text-slate-1000">
                                            Lịch sử link sáng tạo
                                        </div>
                                        <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                            (Xem lịch sử tạo link Hust Media)
                                        </div>
                                        <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                    <Link to="/shop/creative/history_buylink?app=showadview" className="no-underline">
                        <div className="max-w-7xl mx-2 py-0 mb-0">
                            <div className="relative group">
                                <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                    <div className="space-y-2">
                                        <div className="text-lg text-slate-1000">
                                            Lịch sử mua link
                                        </div>
                                        <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                            (Xem lịch sử mua link Hust Media)
                                        </div>
                                        <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default LivestreamViewer;
